<template>
	<el-tooltip v-if="isVisible"
				popper-class="tooltip-md" placement="bottom"
				:disabled="hasAccess"
				:open-delay="500"
	>
		<span v-if="!hasAccess" slot="content" v-html="accessDeniedTooltip"></span>
		<div :class="styleClass + ' ' + (!hasAccess ? 'access_denied_btn_style' : '')">
			<md-button class="w_100"
					   :style="buttonStyle"
					   :class="hasAccess ? buttonClass : ''"
					   :disabled="disabled"
					   @click="click"
			>
				<i v-if="!hasAccess" class="fa fa-lock"/>
				<i v-if="iconClass" :class="iconClass" :style="iconStyle"/>
				{{$t(buttonNameKey)}}
			</md-button>
		</div>
	</el-tooltip>
</template>

<script>
import {accessDeniedTooltip, hasAccess, hasRequiredTraderType} from "@/common/permission/permission";
import {enumDef} from "@/common/enumDefs";

export default {
	props: {
		buttonNameKey: { type: String },
		permission: { type: String, default: null },
		onlyVisibleFor: { type: Array, default: null },
		noAccessDisplayType: { type: String, default: enumDef.noAccessDisplayType.Lock },
		showError: { type: Boolean, default: false },
		styleClass: { type: String, default: "" },
		buttonClass: { type: String, default: "" },
		buttonStyle: { type: String, default: "" },
		iconClass: { type: String, default: "" },
		iconStyle: { type: String, default: "" },
		disabled: { type: Boolean, default: false },
	},
	data() {
		return {
			enumDef: enumDef
		};
	},
	methods: {
		click() {
			if (!this.hasAccess) {
				if (this.showError) {
					this.toast(this.accessDeniedTooltip);
				}
				return;
			}

			this.$emit("click");
		},
	},
	computed: {
		isVisible() {
			let traderTypeMatches = hasRequiredTraderType(this.currentUser, this.onlyVisibleFor);
			let hideIfNoAccess = this.noAccessDisplayType === enumDef.noAccessDisplayType.Hide;

			return (this.hasAccess || !hideIfNoAccess) && traderTypeMatches;
		},
		hasAccess() {
			return hasAccess(this.currentUser, this.permission);
		},
		accessDeniedTooltip() {
			return accessDeniedTooltip(this.currentUser, this.permission);
		},
	}
};
</script>

<style lang="scss" scoped>
.access_denied_btn_style {
	cursor: not-allowed;
}
.fa-lock {
	top: 2px !important;
}
</style>